// gatsby-browser.js
import React from "react";
import Layout from "./src/components/layout/Layout";

export const wrapPageElement = ({ element }) => (
  <Layout>{element}</Layout>
);